import { client } from '@trello/graphql';
import type { BoardListsContextCardFragment } from '@trello/graphql/fragments';
import { BoardListsContextCardFragmentDoc } from '@trello/graphql/fragments';

export const getCardPos = (cardId: string) =>
  client.readFragment<BoardListsContextCardFragment>({
    id: `Card:${cardId}`,
    fragment: BoardListsContextCardFragmentDoc,
  })?.pos;
